import useQuery from './query';
import useMutation from './mutation';

// don't omit the comment below

const hooksApi = {
  useGet: (...args) => useQuery(...args),
  usePost: (...args) => useMutation('post', ...args),
  usePut: (...args) => useMutation('put', ...args),
  usePatch: (...args) => useMutation('patch', ...args),
  useDelete: (...args) => useMutation('delete', ...args),
};

export default hooksApi;
